// @flow
import * as actionTypes from './actionTypes';
import type { Action } from './actions';
import initialState from 'store/initialState';

type servicesType = {
  errorPackages: boolean,
  errorRepair: boolean,
  errorMaintenance: boolean,
  errorRecall: boolean,
  errorDeclined: boolean
};

type errorsType = {
  services: servicesType,
  externalValetLoaner: string,
  dayTime: boolean
};

function reducer(
  state: errorsType = initialState.errors,
  action: Action
): errorsType {
  let services;
  let externalValetLoaner;
  switch (action.type) {
    // SERVICES PAGE
    case actionTypes.RESET_SERVICE_ERRORS: {
      return { ...state, services: initialState.errors.services };
    }
    case actionTypes.ERROR_PACKAGES: {
      services = { ...state.services, errorPackages: action.payload };
      return { ...state, services };
    }
    case actionTypes.ERROR_REPAIR: {
      services = { ...state.services, errorRepair: action.payload };
      return { ...state, services };
    }
    case actionTypes.ERROR_MAINTENANCE: {
      services = { ...state.services, errorMaintenance: action.payload };
      return { ...state, services };
    }
    case actionTypes.ERROR_RECALL: {
      services = { ...state.services, errorRecall: action.payload };
      return { ...state, services };
    }
    case actionTypes.ERROR_DECLINED: {
      services = { ...state.services, errorDeclined: action.payload };
      return { ...state, services };
    }
    // DAY AND TIME PAGE
    case actionTypes.ERROR_DAY_TIME: {
      return { ...state, dayTime: action.payload };
    }
    // TRANSPORTATION PAGE
    case actionTypes.ERROR_APPT_OPTION: {
      return { ...state, apptOption: action.payload };
    }
    case actionTypes.ERROR_NO_CAPACITY: {
      return { ...state, noAdvisors: action.payload };
    }
    // EXTERNAL CLUTCH REQUEST
    case actionTypes.ERROR_FROM_CLUTCH: {
      externalValetLoaner = action.payload;
      return { ...state, externalValetLoaner };
    }
    default:
      return state;
  }
}

export default reducer;



// WEBPACK FOOTER //
// ./src/store/reducers/errors/reducer.js